import React, { useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { toast } from "sonner";

const EMPTY = { leave_type: "casual", start_date: "", end_date: "", reason: "" };

export default function RequestLeaveForm({ onSubmitted }) {
  const [form, setForm] = useState(EMPTY);

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/leaves", form);
      toast.success("Leave request submitted");
      setForm(EMPTY);
      onSubmitted?.();
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    }
  };

  return (
    <form
      onSubmit={submit}
      data-testid="new-leave-form"
      className="max-w-2xl space-y-4 rounded-lg border border-[#e5e5e0] bg-white p-6"
    >
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        <div className="space-y-1.5">
          <Label>Leave type</Label>
          <Select
            value={form.leave_type}
            onValueChange={(v) => setForm({ ...form, leave_type: v })}
          >
            <SelectTrigger data-testid="leave-type-select"><SelectValue /></SelectTrigger>
            <SelectContent>
              <SelectItem value="casual">Casual</SelectItem>
              <SelectItem value="sick">Sick</SelectItem>
              <SelectItem value="earned">Earned</SelectItem>
              <SelectItem value="unpaid">Unpaid</SelectItem>
            </SelectContent>
          </Select>
        </div>
        <div />
        <div className="space-y-1.5">
          <Label htmlFor="l-from">From</Label>
          <Input
            id="l-from"
            data-testid="leave-start-input"
            type="date"
            required
            value={form.start_date}
            onChange={(e) => setForm({ ...form, start_date: e.target.value })}
          />
        </div>
        <div className="space-y-1.5">
          <Label htmlFor="l-to">To</Label>
          <Input
            id="l-to"
            data-testid="leave-end-input"
            type="date"
            required
            value={form.end_date}
            onChange={(e) => setForm({ ...form, end_date: e.target.value })}
          />
        </div>
      </div>
      <div className="space-y-1.5">
        <Label htmlFor="l-reason">Reason</Label>
        <Textarea
          id="l-reason"
          data-testid="leave-reason-input"
          required
          value={form.reason}
          onChange={(e) => setForm({ ...form, reason: e.target.value })}
          placeholder="Add a short reason for your leave…"
        />
      </div>
      <Button
        type="submit"
        data-testid="leave-submit-btn"
        className="bg-[#4a6b53] text-white hover:bg-[#3d5a45]"
      >
        Submit request
      </Button>
    </form>
  );
}
